export const SAVE_ALL_DASHBOARDS = 'SAVE_ALL_DASHBOARDS'
